import React from 'react';

const InfoPanel = ({ show, slideInfo, userAnnotations, cellFeatures, associatedImages }) => {
    if (!show || !slideInfo) return null;

    return (
        <div className="relative bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm
                   rounded-lg shadow-lg p-4 max-w-xs z-20 w-full
                    ">
            <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-2 border-b dark:border-gray-700 pb-2">Slide Information</h3>
            <div className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
                <div><span className="font-medium">Dimensions:</span> {slideInfo.dimensions[0]} × {slideInfo.dimensions[1]}</div>
                <div><span className="font-medium">Apha-boundaries:</span> {JSON.stringify(slideInfo.alpha_boundaries)}</div>
                <div><span className="font-medium">Path:</span> {slideInfo.path}</div>
                <div><span className="font-medium">Levels:</span> {slideInfo.level_count}</div>
                <div><span className="font-medium">Objective:</span> {slideInfo.objective_power}x</div>
                <div><span className="font-medium">Annotations:</span> {userAnnotations.length}</div>
                <div><span className="font-medium">Cells visible:</span> {cellFeatures.length}</div>
            </div>

            {associatedImages && associatedImages.length > 0 && (
                <>
                    <h4 className="font-semibold text-gray-800 dark:text-gray-200 mt-4 mb-2 border-b dark:border-gray-700 pb-2">Associated Images</h4>
                    <div className="space-y-3">
                        {associatedImages.map((img, index) => (
                            <div key={index} className="space-y-1">
                                <div className="text-xs font-medium text-gray-600 dark:text-gray-400">{img.name}</div>
                                <img
                                    src={img.data}
                                    alt={img.name}
                                    className="w-full rounded border border-gray-300 dark:border-gray-600"
                                />
                            </div>
                        ))}
                    </div>
                </>
            )}

        </div>
    );
};

export default InfoPanel;